var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.61641 2.44531L2.44141 3.62031L6.07474 7.25365L5.83307 7.50365H2.49974V12.5036H5.83307L9.99974 16.6703V11.1786L13.4831 14.662C12.9414 15.0703 12.3331 15.3953 11.6664 15.587V17.3036C12.7831 17.0536 13.8081 16.537 14.6747 15.8453L16.3831 17.5536L17.5581 16.3786L3.61641 2.44531ZM8.3331 12.6454L6.52477 10.8371H4.16644V9.1704H6.52477L7.2581 8.43707L8.3331 9.51207V12.6454ZM15.4914 11.9535C15.7081 11.3452 15.8331 10.6868 15.8331 10.0035C15.8331 7.36185 14.0748 5.12852 11.6664 4.41185V2.69518C15.0081 3.45352 17.4998 6.43685 17.4998 10.0035C17.4998 11.1618 17.2331 12.2535 16.7664 13.2285L15.4914 11.9535ZM9.99975 3.33693L8.43308 4.90359L9.99975 6.47026V3.33693ZM11.6664 6.64547C12.8998 7.26214 13.7498 8.5288 13.7498 10.0038C13.7498 10.0705 13.7414 10.1371 13.7331 10.2038L11.6664 8.13714V6.64547Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.beb1864b.svg";
export { ForwardRef as ReactComponent };